import styled from 'styled-components';

import { VerticalHorizontalCenterColumnBlock } from '../../../styled';

export const FetchingWrapper = styled(VerticalHorizontalCenterColumnBlock)`
  min-height: 500px;
`;

export const FetchingTitle = styled.h1`
  ${(props) => props.theme.typography.title}
  margin: 8px 0;
`;

export const FetchingSubtitle = styled.p`
  margin: 0;
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
`;
